import { configureStore } from "@reduxjs/toolkit";
import environmentReducer from "./slices/environmentSlice";
import layoutReducer from "./slices/layoutSlice";
import fileManagerReducer from "./slices/fileManagerSlice";
import authReducer from "./slices/authSlice";
import searchSlice from "./slices/searchSlice";
import ContactSlice from "./slices/contactSlice";
import NewLoginSlice from "./slices/newLoginSlice";
import AudioItemsSlice from "./slices/audioItemsSlice";
import { ENVIRONMENT } from "../environment";
import uploadSlice from "./slices/uploadSlice";
import pathSlice from "./slices/pathSlice";
import SynchSlice from "./slices/synchSlice";
import duplicatedFilesSlice from "./slices/duplicatedFilesSlice";

const store = configureStore({
    reducer: {
        environment: environmentReducer,
        auth: authReducer,
        layout: layoutReducer,
        fileManager: fileManagerReducer,
        search: searchSlice,
        contact: ContactSlice,
        upload: uploadSlice,
        path: pathSlice,
        newLogin: NewLoginSlice,
        audioItems: AudioItemsSlice,
        synchronization: SynchSlice,
        duplicatedFiles: duplicatedFilesSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }),
    devTools: ENVIRONMENT.reduxDevTool
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
